import { render, staticRenderFns } from "./manage-pricing-table.vue?vue&type=template&id=ca23bf78&scoped=true&"
import script from "./manage-pricing-table.vue?vue&type=script&lang=js&"
export * from "./manage-pricing-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca23bf78",
  null
  
)

export default component.exports